import React, { useState } from 'react';
import { 
  Box, 
  Container,
  Typography, 
  Card, 
  CardContent, 
  CardMedia, 
  CardActions, 
  Button, 
  Chip, 
  Avatar, 
  Stack,
  IconButton,
  Tooltip,
  Badge,
  Grid
} from '@mui/material';

import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VerifiedIcon from '@mui/icons-material/Verified';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import VotingApi from '../apis/voting';
import { useEffect } from 'react';
import TurnstileWidget from '../Components/TurnstileWidget';
import { useCallback } from 'react';


const HottestNews = () => {
  // State for likes
  const [trendingNews, setTrendingNews] = useState([]);
  // Set fixed dimensions for card components
  const CARD_HEIGHT = 300; // Fixed height for all cards
  const IMAGE_HEIGHT = 160;
  const TITLE_HEIGHT = 48; // Fixed height for title section
  const SUMMARY_HEIGHT = 72; // Fixed height for summary section
  const [token, setToken] = useState(null);
  // Function to handle liking a news item
  const handleVerify = useCallback((token) => {
    setToken(token);
  }, []);

  // Sample trending news data
  useEffect(() => {

    if (token) {
      VotingApi.getHottest(token).then(response => {
        console.log(response.data);
        setTrendingNews(response.data);
      });
    }
  }, [token]);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 4 }}>
        <WhatshotIcon sx={{ color: 'error.main', fontSize: 30, mr: 1 }} />
        <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
          Trending News
          <TurnstileWidget
            onVerify={handleVerify}
        />
        </Typography>
      </Box>

      <Grid container spacing={3} justifyContent="center">
        {trendingNews.map((news) => (
          <Grid item xs={12} sm={6} md={4} key={news.id}>
            <Card sx={{ 
              width: '100%',
              height: CARD_HEIGHT,
              display: 'flex', 
              flexDirection: 'column',
              transition: 'transform 0.2s, box-shadow 0.2s',
              maxWidth: 1000,
              '&:hover': {
                transform: 'translateY(-5px)',
                boxShadow: 6
              }
            }}>
              <Box sx={{ position: 'relative' }}>
                {/* <CardMedia
                  component="img"
                  height={IMAGE_HEIGHT}
                  image={news.imageUrl}
                  alt={news.title}
                  sx={{ objectFit: 'cover' }}
                /> */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    display: 'flex',
                    alignItems: 'center',
                    bgcolor: 'rgba(0,0,0,0.6)',
                    borderRadius: '12px',
                    px: 1,
                    py: 0.5
                  }}
                >
                  <TrendingUpIcon sx={{ color: 'white', fontSize: 16, mr: 0.5 }} />
                  <Typography variant="caption" sx={{ color: 'white', fontWeight: 'bold' }}>
                    {news.trendingScore}
                  </Typography>
                </Box>
                <Chip
                  label={news.category}
                  size="small"
                  sx={{
                    position: 'absolute',
                    bottom: 10,
                    left: 10,
                    bgcolor: 'primary.main',
                    color: 'white',
                    fontWeight: 'bold'
                  }}
                />
              </Box>
              <CardContent sx={{ 
                flexGrow: 1,
                display: 'flex', 
                flexDirection: 'column',
                padding: 2,
                '&:last-child': { paddingBottom: 2 }, // Override MUI default
              }}>
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1, height: '20px' }}>
                  <Typography variant="caption" color="text.secondary" noWrap>
                    {news.timestamp}
                  </Typography>
                  {news.verified && (
                    <Tooltip title="Verified Source">
                      <VerifiedIcon sx={{ color: 'primary.main', fontSize: 16 }} />
                    </Tooltip>
                  )}
                </Stack>
                <Typography gutterBottom variant="h6" component="div" sx={{ 
                  fontWeight: 'bold', 
                  lineHeight: 1.2,
                  height: TITLE_HEIGHT,
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  mb: 1
                }}>
                  {news.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ 
                  height: SUMMARY_HEIGHT,
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  mb: 2
                }}>
                  {news.main_idea}
                </Typography>
                <Box sx={{ mt: 'auto' }}>
                  <Stack direction="row" spacing={1} alignItems="center" sx={{ width: '100%' }}>

                    <Typography variant="caption" color="text.secondary" noWrap sx={{ ml: 'auto', maxWidth: '40%' }}>
                      {news.source}
                    </Typography>
                  </Stack>
                </Box>
              </CardContent>
              <CardActions sx={{ 
                justifyContent: 'space-between', 
                px: 2, 
                pb: 2,
              }}>
                {/* <Button size="small" variant="contained" color="primary">
                  Read More
                </Button> */}
                {/* <Box>
                  <IconButton 
                    aria-label="add to favorites" 
                    onClick={() => handleLike(news.id)}
                    color={likes[news.id] ? "secondary" : "default"}
                    size="small"
                  >
                    <Badge badgeContent={likes[news.id] || 0} color="secondary">
                      <FavoriteIcon fontSize="small" />
                    </Badge>
                  </IconButton>
                  <IconButton aria-label="share" size="small">
                    <ShareIcon fontSize="small" />
                  </IconButton>
                </Box> */}
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default HottestNews;